import { API_AUTH } from "./common";

const CauHinhThongKeKhachHangApi = {
  danhSach: ({ loai }) =>
    API_AUTH.get(
      `api/cau-hinh-thong-ke-khach-hang/DanhSach?loai=${loai}`,
      {}
    ),
  themMoi: ({ loai, ten }) =>
    API_AUTH.post(`api/cau-hinh-thong-ke-khach-hang/ThemMoi?loai=${loai}`, {
      Ten: ten,
    }),
  capNhat: ({ loai, id, ten }) =>
    API_AUTH.post(
      `api/cau-hinh-thong-ke-khach-hang/CapNhat?loai=${loai}&id=${id}`,
      { Ten: ten }
    ),
  // isActive: 1 = mở khóa, 0 = khóa
  capNhatTrangThai: ({ loai, id, isActive }) =>
    API_AUTH.post(
      `api/cau-hinh-thong-ke-khach-hang/CapNhatTrangThai?loai=${loai}&id=${id}&isActive=${isActive}`
    ),
  xoa: ({ loai, id }) =>
    API_AUTH.post(
      `api/cau-hinh-thong-ke-khach-hang/Xoa?loai=${loai}&id=${id}`
    ),
};

export default CauHinhThongKeKhachHangApi;
